module.exports = __webpack_public_path__ + "static/partenaires-logo-bnp-1ef08040d4b6049b292c06e45fadf034.svg";